module.exports = __webpack_public_path__ + "img/icon_5_74.2c3fe2af.png";